import { render } from "./collection-ticket-rrhh-send.vue?vue&type=template&id=8cf8c908"
import script from "./collection-ticket-rrhh-send.vue?vue&type=script&lang=js"
export * from "./collection-ticket-rrhh-send.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__